import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, EventAttributes } from '~/app/tracking/feld-m-types';

export type GalleryClickEventParams = {
	eventAction: EventAction;
	eventName: string;
	elementName: string;
	pos: string;
	value?: string;
	relatedElements?: EventAttributes['relatedElements'];
};

export class GalleryClickEvent extends BaseEvent {
	constructor({ eventAction, eventName, elementName, value = '', pos, relatedElements }: GalleryClickEventParams) {
		super({
			eventInfo: {
				eventAction,
				eventName,
			},
			attributes: {
				componentName: 'configurator-gallery',
				elementName: elementName ?? '',
				value,
				pos,
				actionType: 'click',
				...(relatedElements && { relatedElements }),
			},
		});
	}
}
